const FILTER_OPTIONS = [
  'Broad Commodities',
  'Precious Metals',
  'Industrial Metals',
  'Energy',
  'Agriculture',
  'EUR Pairs',
  'GBP Pairs',
  'USD Pairs',
  'JPY Pairs',
];

export default FILTER_OPTIONS;
